<template>
  <section class="container py-6 md:pt-10 md:pb-10 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-7 md:gap-y-10">
      <template v-if="isLoading">
        <div v-for="i in 2" :key="i" class="flex">
          <UtilsSkeletonLoading class="w-6 h-7" />
          <div class="ml-4 flex-1">
            <UtilsSkeletonLoading class="w-full mb-2 h-7" />
            <UtilsSkeletonLoading class="w-full h-24" />
          </div>
        </div>
      </template>
      <template v-else>
        <NuxtLink
          v-for="item in solutionsData"
          :key="item.id"
          :to="`/solutions/${item.attributes?.slug}`"
          :title="item.attributes?.title"
          class="flex flex-col gap-3 solution-card p-4 border-b-2 border-transparent hover:border-b-2 hover:border-primary-primary"
        >
          <div class="flex items-start">
            <div class="icon pt-1 w-8 h-8">
              <NuxtImg
                format="webp"
                loading="lazy"
                class="w-full icon"
                :src="item.attributes?.icon?.data?.attributes?.url"
                :alt="item.attributes?.title"
              />
            </div>
            <div class="ml-4 flex-1">
              <div class="flex items-center gap-4 mb-2 solution-title">
                <h3
                  class="text-base md:text-lg text-bw-900 mb-[2px] font-medium title"
                >
                  {{ item.attributes?.title }}
                </h3>
                <NuxtIcon name="chevron-right" />
              </div>
              <div
                class="text-sm md:text-base text-bw-900 description"
                v-html="item?.attributes?.description"
              ></div>
            </div>
          </div>
        </NuxtLink>
      </template>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const solutionsData = ref([])

const getSolutions = async () => {
  const { data, error, pending } = await useSuitmediaApiData(`/api/solutions`, {
    query: {
      'populate[icon][fields][0]': 'url',
      'fields[0]': 'id',
      'fields[1]': 'title',
      'fields[2]': 'description',
      'fields[3]': 'slug',
      'fields[4]': 'order',
      'sort[0]': 'order'
    }
  })

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Solutions does not exist`
    })
  }

  return data.value
}

const solutions = await getSolutions()
solutionsData.value = solutions.data
</script>

<style lang="scss" scoped>
.solution-card {
  &:hover {
    box-shadow: 0px 2px 10px 0px #0000001a;

    .solution-title {
      .title {
        color: #ff6700;
      }
    }

    .icon {
      filter: invert(49%) sepia(56%) saturate(4532%) hue-rotate(0deg)
        brightness(103%) contrast(106%);
    }

    :deep(.nuxt-icon) {
      svg {
        path {
          fill: #ff6700 !important;
        }
      }
    }
  }
}

:deep(.description) {
  strong {
    font-weight: 500 !important;
  }
}
</style>
